export default __webpack_public_path__ + "static/media/downloadDoc.57b0afe3.svg";